export default __webpack_public_path__ + "6ddefb9a86211f59e1fabc6b7ee9a5ae.woff";